'use client';

import { RouteErrorFallback } from '@/components/error/RouteErrorFallback';

export default function MarketingError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteErrorFallback
      error={error}
      reset={reset}
      homeHref="/"
      homeLabel="Go home"
      sectionLabel="this page"
      supportHref="mailto:support@eclipseaccounting.app"
    />
  );
}
